
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"16","height":"16","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M5.097 5.935L8.03 8.83l2.867-2.887a.9.9 0 011.277 1.268l-3.499 3.524a.9.9 0 01-1.27.007L3.832 7.217a.9.9 0 011.265-1.282z","fill":"currentColor","fill-rule":"evenodd"}})])
          )
        }
      }
    